import React from 'react'
import styles from './auth.module.scss'
import { strings } from '../utils/translations'

import DownloadAppIcon from '../../img/illustrations/download_app.svg'
import AppStoreImage from '../../img/store-badges/appstore.svg'
import PlayStoreImage from '../../img/store-badges/playstore.svg'

const SignUpForm = () =>
{
    return (    
        <div className={styles.goToAppContainer}>
            <div>
                <img
                    src={DownloadAppIcon}
                    alt="Download HOMYHUB App"
                />
                <div>{ strings('createAccountFromApp') }</div>
                <div className={styles.storeBadges}>
                    <a href="https://apps.apple.com/app/homyhub/id1226370288" target="_blank">
                        <img src={AppStoreImage} alt="HOMYHUB App Store" />
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.homyhub.app" target="_blank">
                        <img src={PlayStoreImage} alt="HOMYHUB Play Store" />
                    </a>
                </div>
            </div>
        </div>
    )
}

export default SignUpForm
